import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { LVStrings } from "@my-dld/assets/strings";

export function convertToSqFt( sqmt: number ): number {
	let sqft = 0.0;
	sqft = sqmt * 10.764;
	return Number( sqft.toFixed( 2 ) );
}

export function convertToSqMt( sqft: number ): number {
	let sqmt = 0.0;
	sqmt = sqft / 10.764;
	return Number( sqmt.toFixed( 2 ) );
}

enum UnitSystemId {
	METRIC = 1,
	IMPERIAL = 2,
}

export interface UnitSystem {
	Id: number;
	name: LocaleValue;
}

const UnitSystems: UnitSystem[] = [];
export const MetricSystem: UnitSystem = {
	Id: UnitSystemId.METRIC,
	name: LVStrings.sq_mt,
};
UnitSystems.push( MetricSystem );
export const ImperialSystem: UnitSystem = {
	Id: UnitSystemId.IMPERIAL,
	name: LVStrings.sq_ft,
};
UnitSystems.push( ImperialSystem );


export function convertSqMToSqFt( sqmt: number ): number {
	let sqft = 0.0;
	sqft = sqmt * 10.76391041671;
	return Number( sqft.toFixed( 2 ) );
}

export function convertSqFtToSqMt( sqft: number ): number {
	let sqmt = 0.0;
	sqmt = sqft / 10.76391041671;
	return Number( sqmt.toFixed( 2 ) );
}
